import React from 'react';

// muiv5
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';

interface RadioProps {
  id: string;
  label: string;
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (event: any) => void;
  options: Array<{ value: string; label: string }>;
}

const RadioButton = ({ id, label, onChange, options, value }: RadioProps) => {
  return (
    <FormControl id={id}>
      <FormLabel id={`${id}label`}>
        <Typography variant='subtitle1' sx={{ color: 'black.light' }}>
          {label}
        </Typography>
      </FormLabel>
      <RadioGroup
        onChange={onChange}
        row
        defaultValue='all'
        value={value}
        aria-labelledby={`${id}label`}
        name='row-radio-buttons-group'>
        {options?.map((opt: any) => {
          return (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio />}
              label={opt.label}
              sx={{ color: 'black', fontWeight: 400 }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default React.memo(RadioButton);
